import { Navigate, useNavigate } from "react-router-dom";
import { Building2, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function SelectCompany() {
  const { user, isSuper, setActAs, setActiveCompany } = useAuth();
  const navigate = useNavigate();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  const pick = async (c) => {
    if (isSuper) {
      setActAs({ id: c.id, name: c.name });
      navigate("/dashboard");
      return;
    }
    await setActiveCompany(c.id);
    navigate("/");
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6" data-testid="select-company-page">
      <div className="w-full max-w-md">
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Select Company</h1>
        <p className="mt-1 text-sm text-muted-foreground">Aapke paas multiple companies ka access hai. Kis workspace me kaam karna hai?</p>
        <div className="mt-6 space-y-3">
          {(user.companies || []).map((c) => (
            <button key={c.id} data-testid={`select-company-${c.id}`} onClick={() => pick(c)}
              className="group flex w-full items-center gap-3 rounded-xl border bg-card p-4 text-left transition-colors hover:border-primary">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary"><Building2 className="h-5 w-5" /></div>
              <div className="min-w-0 flex-1">
                <div className="truncate font-semibold">{c.name}</div>
                <div className="text-xs capitalize text-muted-foreground">{c.role}</div>
              </div>
              <ArrowRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-1" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
